'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var eventCategories = require('./eventCategories');

var eventTypesByCategory = _defineProperty({}, eventCategories.AUTHENTICATION, {
    LOGIN: 'LOGIN',
    CHANGE_PASSWORD_REQUEST: 'CHANGE_PASSWORD_REQUEST',
    REDEEM_CHANGE_PASSWORD_REQUEST: 'REDEEM_CHANGE_PASSWORD_REQUEST',
    PASSWORD_CHANGED: 'PASSWORD_CHANGED',
    OAUTH_CLIENT_CREDENTIALS_REQUEST: 'OAUTH_CLIENT_CREDENTIALS_REQUEST',
    STORAGE_AUTHENTICATION_CONFIG_REQUEST: 'STORAGE_AUTHENTICATION_CONFIG_REQUEST'
});

module.exports = eventTypesByCategory;